import React from 'react';
import CarregarEvento from '../../../../containers/evento/CarregarEvento';

const Evento  = () => {    
    return <CarregarEvento />
}

export default Evento;